export default function Smoke() {
  const pathStyle = {
    stroke: 'none',
    strokeWidth: 1,
    strokeDasharray: 'none',
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    isCustomFont: 'none',
    fontFileUrl: 'none',
    fill: 'rgb(255, 255, 255)',
    opacity: 1,
  };
  return (
    <svg className="md:h-5 h-4" viewBox="0 0 512.000000 512.000000">
                                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                    fill="currentColor" stroke="none">
                                    <path d="M2323 5104 c-386 -56 -736 -313 -912 -670 -90 -184 -122 -336 -125
                -589 l-1 -170 110 0 110 0 6 200 c7 217 22 295 88 439 115 255 370 472 639
                545 353 96 723 -1 977 -256 199 -200 295 -449 295 -765 0 -43 2 -78 5 -78 3 0
                55 23 115 50 135 62 208 80 326 80 183 0 336 -62 464 -190 85 -85 129 -155
                168 -262 23 -65 26 -88 26 -208 1 -122 -2 -142 -27 -214 -32 -91 -91 -187
                -167 -269 -29 -32 -51 -59 -49 -61 2 -1 40 -29 84 -61 197 -144 323 -333 370
                -556 19 -86 21 -250 5 -337 -49 -273 -231 -513 -483 -637 -233 -114 -475 -123
                -730 -26 -56 21 -103 37 -105 36 -2 -2 -16 -53 -32 -114 -52 -198 -125 -328
                -264 -469 -128 -130 -269 -215 -436 -261 -243 -67 -487 -43 -715 69 -258 127
                -435 341 -521 627 -23 78 -27 112 -33 288 l-6 200 -110 0 -110 0 1 -170 c3
                -253 35 -405 125 -589 159 -322 460 -565 804 -650 540 -132 1106 118 1368 606
                25 46 53 104 62 131 13 35 22 46 34 43 9 -3 56 -12 105 -21 463 -79 939 163
                1158 590 89 174 120 307 120 505 0 298 -100 551 -304 766 l-69 73 26 39 c40
                60 92 193 110 278 16 78 21 253 9 322 -60 352 -329 643 -667 722 -146 34 -245
                35 -418 4 l-35 -6 -12 64 c-37 203 -149 417 -303 582 -272 291 -673 429 -1076
                370z"/>
                                    <path d="M60 3230 l0 -110 725 0 725 0 0 110 0 110 -725 0 -725 0 0 -110z" />
                                    <path d="M500 2560 l0 -110 725 0 725 0 0 110 0 110 -725 0 -725 0 0 -110z" />
                                    <path d="M60 1890 l0 -110 725 0 725 0 0 110 0 110 -725 0 -725 0 0 -110z" />
                                </g>
                            </svg>
  );
}
